import excel from "../../Assets/png/excel.png";
import docs from "../../Assets/png/docs.png";
import imageFile from "../../Assets/png/image.png";
import file from "../../Assets/png/file.png";

export const getAttachmentIcon = (attachment) => {
  const fileSource = (attachment?.name ?? attachment?.url ?? "")
    .toLowerCase()
    .split("?")[0]
    .split("#")[0];
  const extension = fileSource.includes(".")
    ? fileSource.substring(fileSource.lastIndexOf(".") + 1)
    : "";

  if (["xls", "xlsx", "csv"].includes(extension)) return excel;
  if (["pdf"].includes(extension)) return file;
  if (["doc", "docx", "txt", "rtf", "ppt", "pptx"].includes(extension))
    return docs;
  if (["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(extension))
    return imageFile;

  return docs;
};
